var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenancy-info-wrapper" },
    [
      _c("div", { staticClass: "company-info-sec" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              staticClass:
                "company-info input-set small-3 medium-3 large-3 columns",
              class: {
                "required-error-highlight":
                  _vm.inputRequireHighlight &&
                  !_vm.currentTenancy.companyId &&
                  !_vm.isDummyCompany,
              },
            },
            [
              _c("label", { staticClass: "required-flag", class: "emphasis" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenancy.companyId")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search__company search__company--id" },
                [
                  _c("HKLSelect", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    staticClass: "seacrh__company-selector",
                    attrs: {
                      disabled:
                        !_vm.canChangeCompanyNameAndID &&
                        (_vm.isDummyCompany || !_vm.isCreate),
                      value: _vm.companyIdDisplayValue,
                      options: _vm.companyIdHklOptions,
                      showSearch: true,
                      dropdownMatchSelectWidth: true,
                      showArrow: false,
                      openOnFocus: true,
                      filterOption: false,
                      hideNoDataDropdown: true,
                      placeholder: "",
                    },
                    on: {
                      focus: function () {
                        return _vm.searchCompanies({ id: "" })
                      },
                      search: function (val) {
                        return _vm.searchCompanies({ id: val })
                      },
                      change: _vm.selectCompanyId,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isDummyCompany
                          ? false
                          : !_vm.currentTenancy.companyId,
                        expression:
                          "isDummyCompany ? false : !currentTenancy.companyId",
                      },
                    ],
                    staticClass: "fa fa-search",
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "company-info input-set small-5 medium-5 large-5 columns",
              class: {
                "required-error-highlight":
                  _vm.inputRequireHighlight &&
                  !_vm.deep(_vm.currentTenancy, "company.name"),
              },
            },
            [
              _c("label", { staticClass: "required-flag", class: "emphasis" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenancy.companyName")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "search__company search__company--name" },
                [
                  _c("HKLSelect", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    staticClass: "seacrh__company-selector",
                    attrs: {
                      disabled:
                        (!_vm.canChangeCompanyNameAndID &&
                          !_vm.isCreate &&
                          !_vm.isDummyCompany &&
                          !_vm.currentTenancy.companyChangeNotSaved) ||
                        _vm.disableUpdate,
                      value: _vm.companyName || undefined,
                      options: _vm.companyNameHklOptions,
                      showSearch: true,
                      dropdownMatchSelectWidth: true,
                      showArrow: false,
                      singleTaggableInput: true,
                      placeholder: "",
                    },
                    on: {
                      search: _vm.onCompanyNameSearch,
                      input: _vm.onCompanyNameInput,
                      change: _vm.onCompanyNameChange,
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.companyName,
                        expression: "!companyName",
                      },
                    ],
                    staticClass: "fa fa-search",
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "company-info small-3 medium-3 large-3 columns" },
            [
              _c("label", { staticClass: "emphasis required-flag" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.tradeName"))),
              ]),
              _vm._v(" "),
              _c("HKLSelect", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                staticClass: "seacrh__tradeName-selector",
                class: {
                  "error-highlight":
                    _vm.inputRequireHighlight && !_vm.currentTenancy.tradeName,
                },
                attrs: {
                  disabled: _vm.disableUpdate,
                  value: _vm.currentTenancy.tradeName || undefined,
                  options: _vm.tradeNameHklOptions,
                  showSearch: true,
                  dropdownMatchSelectWidth: true,
                  showArrow: false,
                  singleTaggableInput: true,
                  openOnFocus: true,
                  hideNoDataDropdown: true,
                  placeholder: "",
                },
                on: {
                  input: _vm.onTradeNameInput,
                  change: _vm.onTradeNameChange,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "input-set small-3 medium-3 large-3 columns" },
            [
              _c("label", { class: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.generalLine"))),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "generalline" }, [
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  attrs: { type: "text", disabled: true },
                  domProps: {
                    value:
                      _vm.deep(_vm.currentTenancy, "company.phone") ||
                      (_vm.isDummyCompany ? "" : "--"),
                  },
                  on: {
                    change: function (event) {
                      return _vm.updateCompanyPathField(
                        "phone",
                        event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-set small-3 medium-3 large-3 columns" },
            [
              _c("label", { class: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.alternativePhoneNumber"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                attrs: { type: "text", disabled: true },
                domProps: {
                  value:
                    _vm.deep(_vm.currentTenancy, "company.altPhone") ||
                    (_vm.isDummyCompany ? "" : "--"),
                },
                on: {
                  change: function (event) {
                    return _vm.updateCompanyPathField(
                      "altPhone",
                      event.target.value
                    )
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-set small-3 medium-3 large-3 columns" },
            [
              _c("label", { class: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.faxNumber"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                attrs: { type: "text", disabled: true },
                domProps: {
                  value:
                    _vm.deep(_vm.currentTenancy, "company.fax") ||
                    (_vm.isDummyCompany ? "" : "--"),
                },
                on: {
                  change: function (event) {
                    return _vm.updateCompanyPathField("fax", event.target.value)
                  },
                },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "input-set small-3 medium-3 large-3 columns" },
            [
              _c("label", { class: "emphasis" }, [
                _vm._v(_vm._s(_vm.$t("tenancy.email"))),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                attrs: { type: "text", disabled: true },
                domProps: {
                  value:
                    _vm.deep(_vm.currentTenancy, "company.email") ||
                    (_vm.isDummyCompany ? "" : "--"),
                },
                on: {
                  change: function (event) {
                    return _vm.updateCompanyPathField(
                      "email",
                      event.target.value
                    )
                  },
                },
              }),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "premises-info-sec" }, [
        !_vm.currentTenancy.id
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "input-set main__contact-name small-3 medium-3 large-3 columns",
                },
                [
                  _c("label", { staticClass: "emphasis required-flag" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.mainContact")) + " "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                      return _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        key: fullnameObj.key,
                        staticClass: "small-6 medium-6 large-6 columns",
                        class: {
                          "error-highlight":
                            _vm.inputRequireHighlight &&
                            !_vm.currentTenancy[fullnameObj.value],
                        },
                        attrs: {
                          placeholder: _vm.$t(
                            "contact.basic." + fullnameObj.label
                          ),
                          type: "text",
                        },
                        domProps: {
                          value: _vm.currentTenancy[fullnameObj.value],
                        },
                        on: {
                          change: function (event) {
                            return _vm.updatePathField(
                              fullnameObj.value,
                              event.target.value
                            )
                          },
                        },
                      })
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-set small-3 medium-3 large-3 columns" },
                [
                  _c("label", { class: "emphasis" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.phoneNumber")) + " "),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && _vm.isSamePhoneNumbers(),
                    },
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentTenancy.phone },
                    on: {
                      change: function (event) {
                        return _vm.updatePathField("phone", event.target.value)
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-set small-3 medium-3 large-3 columns" },
                [
                  _c("label", { class: "emphasis" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.alternativePhoneNumber"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && _vm.isSamePhoneNumbers(),
                    },
                    attrs: { type: "text" },
                    domProps: { value: _vm.currentTenancy.altPhone },
                    on: {
                      change: function (event) {
                        return _vm.updatePathField(
                          "altPhone",
                          event.target.value
                        )
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "main__contact-email small-3 medium-3 large-3 columns",
                },
                [
                  _c("label", { staticClass: "emphasis required-flag" }, [
                    _vm._v(_vm._s(_vm.$t("user.email"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      { name: "hkldinput", rawName: "v-hkldinput" },
                      {
                        name: "fusioninputcheck",
                        rawName: "v-fusioninputcheck",
                        value: {
                          type: "string",
                          pattern: _vm.regex.email,
                          classes: "tooltip-class",
                          tip: _vm.tips.email,
                          required: true,
                        },
                        expression:
                          "{\n            type: 'string',\n            pattern: regex.email,\n            classes: 'tooltip-class',\n            tip: tips.email,\n            required: true\n          }",
                      },
                    ],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && !_vm.currentTenancy.email,
                    },
                    attrs: { type: "email" },
                    domProps: { value: _vm.currentTenancy.email },
                    on: {
                      change: function (event) {
                        return _vm.updatePathField("email", event.target.value)
                      },
                    },
                  }),
                ]
              ),
            ])
          : _vm.adminAccount && _vm.adminAccount.TenancyAccount
          ? _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "input-set main__contact-name small-3 medium-3 large-3 columns",
                },
                [
                  _c("label", { staticClass: "emphasis required-flag" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.mainContact"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                      return _c("input", {
                        directives: [
                          { name: "hkldinput", rawName: "v-hkldinput" },
                        ],
                        key: fullnameObj.key,
                        staticClass: "small-6 medium-6 large-6 columns",
                        class: {
                          "error-highlight":
                            _vm.inputRequireHighlight &&
                            !_vm.adminAccount.TenancyAccount[
                              "contact" + fullnameObj.key
                            ],
                        },
                        attrs: {
                          type: "text",
                          disabled: _vm.disableUpdateMasterAccount,
                        },
                        domProps: {
                          value:
                            _vm.adminAccount.TenancyAccount[
                              "contact" + fullnameObj.key
                            ],
                        },
                        on: {
                          change: function (event) {
                            _vm.adminAccount.TenancyAccount[
                              "contact" + fullnameObj.key
                            ] = event.target.value
                            _vm.updateAdminAccount()
                          },
                        },
                      })
                    }),
                    0
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-set small-3 medium-3 large-3 columns" },
                [
                  _c("label", { staticClass: "emphasis" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.phoneNumber"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && _vm.isSamePhoneNumbers(),
                    },
                    attrs: { type: "text", disabled: _vm.disableUpdate },
                    domProps: { value: _vm.adminAccount.TenancyAccount.phone },
                    on: {
                      change: function (event) {
                        _vm.adminAccount.TenancyAccount.phone =
                          event.target.value
                        _vm.updateAdminAccount()
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-set small-3 medium-3 large-3 columns" },
                [
                  _c("label", { class: "emphasis" }, [
                    _vm._v(_vm._s(_vm.$t("tenancy.alternativePhoneNumber"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && _vm.isSamePhoneNumbers(),
                    },
                    attrs: { type: "text", disabled: _vm.disableUpdate },
                    domProps: {
                      value: _vm.adminAccount.TenancyAccount.altPhone,
                    },
                    on: {
                      change: function (event) {
                        _vm.adminAccount.TenancyAccount.altPhone =
                          event.target.value
                        _vm.updateAdminAccount()
                      },
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "main__contact-email small-3 medium-3 large-3 columns",
                },
                [
                  _c("label", { staticClass: "emphasis required-flag" }, [
                    _vm._v(_vm._s(_vm.$t("user.email"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      { name: "hkldinput", rawName: "v-hkldinput" },
                      {
                        name: "fusioninputcheck",
                        rawName: "v-fusioninputcheck",
                        value: {
                          type: "string",
                          pattern: _vm.regex.email,
                          classes: "tooltip-class",
                          tip: _vm.tips.email,
                          required: true,
                        },
                        expression:
                          "{\n            type: 'string',\n            pattern: regex.email,\n            classes: 'tooltip-class',\n            tip: tips.email,\n            required: true\n          }",
                      },
                    ],
                    class: {
                      "error-highlight":
                        _vm.inputRequireHighlight && !_vm.adminAccount.username,
                    },
                    attrs: {
                      type: "email",
                      disabled: _vm.disableUpdateMasterAccount,
                    },
                    domProps: { value: _vm.adminAccount.username },
                    on: {
                      change: function (event) {
                        _vm.adminAccount.username = event.target.value
                        _vm.updateAdminAccount()
                      },
                    },
                  }),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.disableOpeningHourInEdit
          ? _c(
              "div",
              { staticClass: "tenancy-working-hours" },
              [
                _c("label", [
                  _vm._v(
                    _vm._s(
                      _vm.showHolidayHour
                        ? _vm.$t("tenancy.regularOpeningHours")
                        : _vm.$t("tenancy.openingHours")
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("WorkingHours", {
                  attrs: {
                    hideLabel: true,
                    checkTimeValidate: false,
                    disabled: _vm.disableUpdate,
                    workingHours: _vm.openingHours.regularWorkingHours || [],
                    updateValueByPath: _vm.updateOpeningHours,
                    fieldPath: ["regularWorkingHours"],
                  },
                }),
                _vm._v(" "),
                _vm.showHolidayHour
                  ? [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("tenancy.holidayOpeningHours"))),
                      ]),
                      _vm._v(" "),
                      _c("HolidayOpeningHours", {
                        attrs: {
                          hideLabel: true,
                          workingHours:
                            _vm.openingHours.holidayWorkingHours || [],
                          updateValueByPath: _vm.updateOpeningHours,
                          fieldPath: ["holidayWorkingHours"],
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "alarm-section" }, [
          _c("div", { staticClass: "alarm-section__label-btn" }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("tenancy.alarmSysHint")))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fire-alarm-section" }, [
            _c("label", { staticClass: "emphasis alarm-label" }, [
              _vm._v(_vm._s(_vm.$t("tenancy.fireAlarmSystem")) + ":"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "alarm-checkbox",
              attrs: {
                disabled: _vm.disableUpdate,
                type: "radio",
                name: "fireAlarm",
              },
              domProps: { checked: _vm.currentTenancy.isFireAlarm },
              on: {
                change: function ($event) {
                  return _vm.updatePathField("isFireAlarm", true)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "alarm-checkbox-label" }, [
              _vm._v(_vm._s(_vm.$t("action.yes"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "alarm-checkbox",
              attrs: {
                disabled: _vm.disableUpdate,
                type: "radio",
                name: "fireAlarm",
              },
              domProps: {
                checked:
                  ![null, undefined].includes(_vm.currentTenancy.isFireAlarm) &&
                  !_vm.currentTenancy.isFireAlarm,
              },
              on: {
                change: function ($event) {
                  return _vm.updatePathField("isFireAlarm", false)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "alarm-checkbox-label" }, [
              _vm._v(_vm._s(_vm.$t("action.no"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("label", { staticClass: "emphasis alarm-label" }, [
              _vm._v(_vm._s(_vm.$t("tenancy.burglarAlarmSystem")) + ":"),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "alarm-checkbox",
              attrs: {
                disabled: _vm.disableUpdate,
                type: "radio",
                name: "burglarAlarm",
              },
              domProps: { checked: _vm.currentTenancy.isBurglarAlarm },
              on: {
                change: function ($event) {
                  return _vm.updatePathField("isBurglarAlarm", true)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "alarm-checkbox-label" }, [
              _vm._v(_vm._s(_vm.$t("action.yes"))),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
              staticClass: "alarm-checkbox",
              attrs: {
                disabled: _vm.disableUpdate,
                type: "radio",
                name: "burglarAlarm",
              },
              domProps: {
                checked:
                  ![null, undefined].includes(
                    _vm.currentTenancy.isBurglarAlarm
                  ) && !_vm.currentTenancy.isBurglarAlarm,
              },
              on: {
                change: function ($event) {
                  return _vm.updatePathField("isBurglarAlarm", false)
                },
              },
            }),
            _vm._v(" "),
            _c("label", { staticClass: "alarm-checkbox-label" }, [
              _vm._v(_vm._s(_vm.$t("action.no"))),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("hr"),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "premise-floor" },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "input-set building-selector small-3 medium-3 large-3 columns",
                class: {
                  "required-error-highlight":
                    _vm.inputRequireHighlight && !_vm.currentTenancy.building,
                },
              },
              [
                _c("label", { staticClass: "emphasis required-flag" }, [
                  _vm._v(_vm._s(_vm.$t("tenancy.building"))),
                ]),
                _vm._v(" "),
                _c("HKLSelect", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "seacrh__building-selector",
                  attrs: {
                    disabled:
                      _vm.disableUpdate ||
                      (!_vm.allowLinkContacts && _vm.disableBuildingUpdate),
                    value: _vm.currentTenancy.buildingId || undefined,
                    options: _vm.buildingHklOptions,
                    showSearch: true,
                    placeholder: "",
                    fusionInputCheckPattern: _vm.bulidingSelectorValidateFunc,
                    required: true,
                    showTip: false,
                  },
                  on: { change: _vm.onBuildingChange },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "disabled-input-wrapper small-3 medium-3 large-3 columns",
              },
              [
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "radioClass",
                  attrs: {
                    id: "office",
                    disabled: !_vm.acTenancyIsOffice || _vm.disableUpdate,
                    name: "type",
                    type: "radio",
                  },
                  domProps: { checked: _vm.isOfficeType },
                  on: {
                    change: function (event) {
                      return _vm.updatePathField("type", _vm.tenancyType.Office)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    class: { "text-bold": _vm.isOfficeType },
                    attrs: { for: "office" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tenancy.office")) +
                        "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                  staticClass: "radioClass",
                  attrs: {
                    id: "retail",
                    disabled: !_vm.acTenancyIsRetail || _vm.disableUpdate,
                    name: "type",
                    type: "radio",
                  },
                  domProps: { checked: !_vm.isOfficeType },
                  on: {
                    change: function (event) {
                      return _vm.updatePathField("type", _vm.tenancyType.Retail)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    class: { "text-bold": !_vm.isOfficeType },
                    attrs: { for: "retail" },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("tenancy.retail")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-set building" }, [
              _c(
                "div",
                {
                  staticClass: "search-zone",
                  class: {
                    "required-error-highlight": _vm.zoneValidationFailed,
                  },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "emphasis",
                      class: { "required-flag": _vm.zoneFieldRequired },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("tenancy.zone")) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("HKLMultiSelect", {
                    directives: [{ name: "hkldinput", rawName: "v-hkldinput" }],
                    staticClass: "search-zone-selector",
                    class: { "error-highlight": _vm.zoneValidationFailed },
                    attrs: {
                      disabled:
                        !_vm.zoneOptions ||
                        _vm.zoneOptions.length <= 1 ||
                        _vm.disableUpdate,
                      value: _vm.zoneMultiValue,
                      options: _vm.zoneHklOptions,
                      dropdownMatchSelectWidth: false,
                      placeholder: "",
                    },
                    on: { change: _vm.onZonesChange },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            !_vm.isTenant && _vm.isCurrentRegionHK
              ? _c(
                  "div",
                  { staticClass: "e-key building" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ekeyEnabled,
                          expression: "ekeyEnabled",
                        },
                      ],
                      attrs: { type: "checkbox", disabled: _vm.disableUpdate },
                      domProps: {
                        checked: Array.isArray(_vm.ekeyEnabled)
                          ? _vm._i(_vm.ekeyEnabled, null) > -1
                          : _vm.ekeyEnabled,
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.ekeyEnabled,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 && (_vm.ekeyEnabled = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.ekeyEnabled = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.ekeyEnabled = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "emphasis", attrs: { for: "eKey" } },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("tenancy.pm-t006")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.ekeyEnabled
                      ? _c("TextField", {
                          attrs: {
                            readonly: _vm.disableUpdate,
                            value: _vm.currentTenancy.eKey,
                          },
                          on: {
                            updateValue: function (value) {
                              return _vm.updatePathField("eKey", value)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("TextField", {
            staticClass: "all-linked-premises",
            attrs: {
              label: _vm.$t("tenancy.premises"),
              value: _vm.premises,
              showColon: false,
              readonly: true,
            },
          }),
          _vm._v(" "),
          _vm._l(_vm.premisesDetailList, function (info, index) {
            return _c(
              "div",
              { key: index + _vm.timeStamp, staticClass: "row premise-detail" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "input-set detail small-3 medium-3 large-3 columns",
                  },
                  [
                    !index
                      ? _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenancy.premisedetail")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("TextField", {
                      attrs: {
                        readonly: _vm.disableUpdate,
                        readonlyAsInput: _vm.disableUpdate,
                        showColon: false,
                        value: info.detail || "",
                      },
                      on: {
                        updateValue: function (val) {
                          return _vm.editPremiseInfo("detail", index, val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "input-set floor small-3 medium-3 large-3 columns",
                  },
                  [
                    !index
                      ? _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenancy.floor")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("HKLSelect", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                      ],
                      attrs: {
                        disabled:
                          _vm.disableUpdate ||
                          (!_vm.allowLinkContacts &&
                            _vm.premiseCanBeUpdated(info)),
                        value: info.floor || undefined,
                        options: _vm.floorHklOptions,
                        showSearch: true,
                        placeholder: "",
                      },
                      on: {
                        change: function (val) {
                          return _vm.editPremiseInfo("floor", index, val)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "effectiveDate small-2 medium-2 large-2 columns",
                  },
                  [
                    !index
                      ? _c("label", { staticClass: "emphasis required-flag" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("tenancy.effectiveDate")) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("DatePicker", {
                      staticClass: "columns",
                      attrs: {
                        calendarButton: true,
                        calendarButtonIcon: "fa fa-calendar",
                        value: _vm.formatDate(info.effectiveDate),
                        placeholder: "",
                        disabledPicker: _vm.disableUpdate,
                        disabled: {
                          from: info.endDate
                            ? new Date(info.endDate)
                            : undefined,
                        },
                      },
                      on: {
                        selected: function (val) {
                          return _vm.editPremiseInfo(
                            "effectiveDate",
                            index,
                            val
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isCreate
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "end-date small-2 medium-2 large-2 columns",
                      },
                      [
                        !index
                          ? _c("label", { staticClass: "emphasis" }, [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("tenancy.endDate")) +
                                  "\n        "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("DatePicker", {
                          staticClass: "columns",
                          attrs: {
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            value: _vm.formatDate(info.endDate),
                            placeholder: "",
                            disabledPicker: _vm.disableUpdate,
                            disabled: {
                              to: info.effectiveDate
                                ? new Date(info.effectiveDate)
                                : undefined,
                            },
                          },
                          on: {
                            selected: function (val) {
                              return _vm.editPremiseInfo("endDate", index, val)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !(
                  _vm.disableUpdate ||
                  (!_vm.allowLinkContacts && _vm.premiseCanBeUpdated(info))
                )
                  ? _c(
                      "div",
                      {
                        staticClass: "premise-detail__actions columns end",
                        class: _vm.isCreate
                          ? "small-4 medium-4 large-4"
                          : "small-2 medium-2 large-2",
                      },
                      [
                        !index
                          ? _c(
                              "label",
                              {
                                staticClass:
                                  "emphasis premise-detail__actions-label-spacer",
                                attrs: { "aria-hidden": "true" },
                              },
                              [_vm._v(" ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "premise-detail__delete-button",
                            on: {
                              click: function ($event) {
                                return _vm.openDeleteConfirmModel(index)
                              },
                            },
                          },
                          [_vm._m(0, true)]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.disableUpdate
            ? _c(
                "i",
                {
                  staticClass: "add-premise-detail",
                  on: { click: _vm.addPremiseInfo },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("tenancy.addNewPremisesFloorDetail")) +
                      "\n    "
                  ),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("DeleteConfirmModel", {
        ref: "deletePremiseInfoConfirmModel",
        attrs: { deleteFunction: _vm.deletePremiseInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("span", {
        staticClass: "fa fa-times fa-lg",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }